import initialState from '../initialState';

export const userReducer = (state = initialState.bfiUser, action) => {
    return { ...state, ...action.state };
};

export default userReducer;
